import VueDOMPurifyHTML from 'vue-dompurify-html'
import vSelect from 'vue-select'
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueDOMPurifyHTML)
  nuxtApp.vueApp.use(vSelect)
})
